import { render, staticRenderFns } from "./RootParkingOccupancy.vue?vue&type=template&id=bcabddba&scoped=true&"
import script from "./RootParkingOccupancy.vue?vue&type=script&lang=js&"
export * from "./RootParkingOccupancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcabddba",
  null
  
)

export default component.exports